import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Divider, Switch, Text } from '@hh.ru/magritte-ui';

import { useCalculatorContext } from 'src/pages/Profession/components/SectionCalculator/Context';

import styles from './styles.less';

const TrlKeys = {
    fillSkills: 'career-platform.profession.sections.calculator.fill-skills',
};

const CalculatorFillSkillsToggle: TranslatedComponent = ({ trls }) => {
    const {
        fillByProfile: { isFilled, handleFill, isHidden },
    } = useCalculatorContext();

    if (isHidden) {
        return null;
    }

    return (
        <>
            <label className={styles.fillSkills}>
                <Text typography="label-2-regular" Element="p">
                    {trls[TrlKeys.fillSkills]}
                </Text>
                <div className={styles.fillSkillsButton}>
                    <Switch checked={isFilled} onClick={handleFill} />
                </div>
            </label>
            <Divider />
        </>
    );
};
export default translation(CalculatorFillSkillsToggle);
